import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";

export const PhotoPicker = ({ onFile, disabled, label, testId, className = "" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try { await onFile(file); } finally { setBusy(false); }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testId}-input`} />
      <button
        type="button"
        disabled={disabled || busy}
        onClick={() => ref.current?.click()}
        data-testid={testId}
        className={`tap-target inline-flex items-center justify-center gap-2 rounded-md border border-[#2A2E39] bg-[#0B0C10] text-slate-300 hover:border-[#636b2f] hover:text-[#A9B26A] disabled:opacity-40 transition-colors ${className}`}
      >
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Camera className="w-5 h-5" />}
        {label && <span className="text-sm font-semibold">{busy ? "Enviando..." : label}</span>}
      </button>
    </>
  );
};
